import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statHandleReportLocaleModule: LocaleModule = {
  name: "statHandleReport",
  messages: { en: en, it: it },
};
